<template>
  <div class="bell" @click="onClick">
    <img src="@/assets/images/bell.png" alt="提醒">
  </div>
</template>

<script>
export default {
  name: 'bell',
  methods: {
    onClick() {
      this.$emit('click', this)
    }
  }
}

</script>
<style scoped lang="scss">
.bell {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 20px;
  }
}
</style>